export const GET_COUNTRIES_REQUEST = "GET_COUNTRIES_REQUEST";
export const GET_COUNTRIES_RESPONSE = "GET_COUNTRIES_RESPONSE";
